export class PrivacyManagerSettings {
  constructor(overrides = {}) {
    const defaults = {
      width: { type: 'px', value: 600 },
      height: { type: 'auto', value: 1 },
      padding: { paddingLeft: 0, paddingRight: 0, paddingTop: 0, paddingBottom: 0 },
      border: { borderWidth: 0, borderColor: '#000000', borderTopLeftRadius: 10, borderTopRightRadius: 10, borderBottomLeftRadius: 10, borderBottomRightRadius: 10, borderStyle: 'solid' },
      background: '#ffffff',
      closeAlign: 'right',
      closeFont: { fontSize: 16, fontWeight: '500', color: '#999999', fontFamily: 'arial, helvetica, sans-serif' },
      showClose: false,
      showVeil: true,
      lockScroll: true,
      useSafeArea: false,
      veilColor: '#000000',
      veilOpacity: 0.65,
      type: 'modal',
      zIndex: 2147483000,
      useStacks: false,
      usePurModel: false,
      consentOnlyStacks: false,
      defaultTab: 'purposes',
      url: '',
      vendorList: null,
      type_settings: { targetType: 'id', targetName: '', dismissable: false },
      defaultLanguage: overrides.language || 'EN',
      useBrowserDefault: false,
      supportedLanguages: []
    };
    Object.assign(this, defaults, overrides);
  }
}

export const PrivacyManagerTypes = {
  'Privacy Manager Settings': {
    vendorList: { title: 'Vendor List Preview', type: 'VendorList' },
    useStacks: { title: 'Use stacks?', type: 'Switch' },
    consentOnlyStacks: { title: 'Show stacks for consent only?', type: 'Switch' },
    usePurModel: { title: 'Use Pur Model? When enabled there will be no toggles for purposes or vendors under the legal basis "consent"', type: 'Switch' },
    defaultTab: { title: 'Default Tab', type: 'DefaultTab' },
  },
  language: {
    language: { title: 'Default Language', type: 'Language' },
    useBrowserDefault: { title: 'Use Browser Default', type: 'Switch' },
  },
  settings: {
    lockScroll: { title: 'Disable Scrolling?', type: 'Switch' },
    useSafeArea: { title: 'Constrain Privacy Manager to mobile safe area?', type: 'Switch' },
    zIndex: { title: 'Z-Index', type: 'ZIndex' },
    url: { title: 'Website BG', type: 'Input' },
  },
  orientation: {
    width: { title: 'Width', type: 'Size' },
    padding: { title: 'Padding', type: 'Padding' },
  },
  styles: {
    background: { title: 'Background Color', type: 'ColorPicker' },
    border: { title: 'Border', type: 'Border' },
  },
  veil: {
    showVeil: { title: 'Show?', type: 'Switch' },
    veilColor: { title: 'Color', type: 'ColorPicker' },
    veilOpacity: { title: 'Opacity', type: 'Opacity' },
  },
};